export default __webpack_public_path__ + "static/media/NH21_723_ELLE_LUISA_2417.251376e1.jpg";